var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "objective-section" }, [
    _c("header", { staticClass: "objective-section__header" }, [
      _c(
        "p",
        {
          staticClass:
            "objective-section__title typographies-paragraph-large-bold"
        },
        [_vm._t("icon"), _vm._v(" "), _vm._t("title")],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "article",
      { staticClass: "objective-section__content" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }